import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'
import moment from 'moment'
import keycloak from '../../../common/Keycloak';

export default {
  name: 'shoPODpendingCount',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  mixins:[PageTracker],
  props: [],
  data: function() {
    return {
      listUserData: [],
      userWithPendingShipment: [],
      currentHub: [],
      listofPendingCount: [],
      currenthub: '',
      userid: '',
      srListLoader: false,
      isLoading: false,
      isLoadingPSLModel: false,
      pendingShipModel: false,
      dataFound:true,
      notFound:false,
      userDataKey : '',
    }
  },
  computed: {

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub.push(userdetail.hubdetails[0]);
    this.currenthub = userdetail.hubdetails[0];
    this.getSRUserList();
    this.getDeliveryWisePODpendingCount();

    // let TrackerInfo = {
    //     projectname:"Lastmile-web",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.useremail,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  methods: {
    customLabel({
      FirstName,
      LastName,
      userid,
      OldDeliveryUserOrUserId,
      MobileNumber
    }) {
      return `${FirstName} ${LastName}(${userid}) (${OldDeliveryUserOrUserId}) - ${MobileNumber}`
    },
    getDeliveryWisePODpendingCount() {
      this.srListLoader = true;
      this.input = ({
        hubid: this.currenthub,
        userid: this.userid.userid
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'expose/SrRunSheet/getDeliveryWisePODpendingCount',
        'data': this.input,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(result => {
        if (result.data.code == 200) {
          this.userWithPendingShipment = result.data.data;
        } else {
          this.notFound=true
          this.userWithPendingShipment = []
        }
        this.srListLoader = false;
      }, error => {
        console.error(error)
        this.srListLoader = false;
        this.notFound=true;
      })
    },
    getSRUserList() {
      this.isLoading = true;
      this.input = ({
        hubid: this.currentHub,
        usertype: "3"
      });
      let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
      if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/gethubdeliveryuserlist';
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + apiendpoint,
        'data': this.input,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(result => {
        this.listUserData = result.data.data.results;
        this.isLoading = false;
      }, error => {
        console.error(error)
        this.isLoading = false;
      })
    },
    openModal(DeliveryUserId) {
      this.pendingShipModel = true
      this.isLoadingPSLModel = true
      this.input = ({
        userid: DeliveryUserId,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'expose/SrRunSheet/getPODpendingShipments',
        'data': this.input,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(result => {
        if (result.data.code==202) {
          this.dataFound=false
        }
        this.listofPendingCount = result.data.data;
        this.isLoadingPSLModel = false;
      }, error => {
        console.error(error)
        this.isLoadingPSLModel = false;
      })
    },
    closePendingShipModel() {
      this.pendingShipModel = false
    },
    Search(){
      if (typeof this.userid==='undefined' || this.userid==='') {
        this.$alertify.error("Please select any option")
        return false;
      }else {
        this.getDeliveryWisePODpendingCount()
      }
    },
    clear() {
      this.userid = ''
      this.$validator.reset()
      this.errors.clear()
      this.getDeliveryWisePODpendingCount()
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/showPODpending/showPODpending.component.js